import { create } from 'zustand'
import { AssetCategory } from '../types/assetCategory'
import { assetCategoryService } from '../services/assetCategoryService'

interface AssetCategoryState {
  categories: AssetCategory[]
  loading: boolean
  error: string | null

  // Actions
  loadCategories: (customerId: string, status?: string) => Promise<void>
  reset: () => void
}

export const useAssetCategoryStore = create<AssetCategoryState>((set) => ({
  categories: [],
  loading: false,
  error: null,

  loadCategories: async (customerId: string, status?: string) => {
    set({ loading: true, error: null })
    try {
      const categories = await assetCategoryService.getAssetCategories(customerId, status)
      set({ categories, loading: false })
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to load categories'
      set({ error: errorMessage, loading: false })
    }
  },

  reset: () => {
    set({
      categories: [],
      loading: false,
      error: null
    })
  }
}))
